import { StudioChecklistTaskStatus } from './studioChecklist';

interface StatusMarkIconProps {
  status: StudioChecklistTaskStatus;
}

export const StatusMarkIcon = ({ status }: StatusMarkIconProps) => {
  if (status === StudioChecklistTaskStatus.Done) {
    return (
      <span
        aria-hidden="true"
        className="box-border flex size-3.5 shrink-0 items-center justify-center rounded-full bg-black-heading"
      >
        <span className="-mt-px block h-[7px] w-[4px] rotate-45 border-b-[1.5px] border-r-[1.5px] border-solid border-white" />
      </span>
    );
  }

  if (status === StudioChecklistTaskStatus.InProgress) {
    return (
      <span
        aria-hidden="true"
        className="box-border block size-3.5 shrink-0 rounded-full border-[1.5px] border-solid border-light-gray text-light-gray"
        style={{
          backgroundImage:
            'linear-gradient(90deg, currentColor 50%, transparent 50%)',
        }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className="box-border block size-3.5 shrink-0 rounded-full border-[1.5px] border-solid border-light-gray"
    />
  );
};
